import styled from 'styled-components';

const RenderColumnWrapper = styled.div`
  form {
    padding: 20px;
  }
`;

export default RenderColumnWrapper;
